export class AysFabStore {
  constructor(private readonly _baseUrl: string) {}

  public indexResource(): string {
    return `${this._baseUrl}/`;
  }

  public byFabKeyResource(fabKey: string): string {
    const baseUrl = this.indexResource();

    return `${baseUrl}${fabKey}`;
  }
}
